import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app/app'
import notification from '@/store/modules/app/notification'
import auth from '@/store/modules/auth/auth'
import events from '@/store/modules/app/events'
import account from '@/store/modules/account/account'
import accountResume from '@/store/modules/account/accountResume'
import accountTransaction from '@/store/modules/account/accountTransaction'
import accountTransfer from '@/store/modules/account/accountTransfer'
import accountPlan from '@/store/modules/account/accountPlan'
import accountCashFlow from '@/store/modules/account/accountCashFlow'
import person from '@/store/modules/person/person'
import purchase from '@/store/modules/purchase/purchase'
import product from '@/store/modules/product/product'
import drawer from '@/store/modules/account/drawer'
import xml from '@/store/modules/invoice/xml'
import invoice from '@/store/modules/invoice/invoice'
import order from '@/store/modules/order/order'
import orderForm from '@/store/modules/order/orderForm'
import products from '@/store/modules/product/products'
import billpayable from '@/store/modules/billPayable/billpayable'
import billreceiveble from '@/store/modules/billReceiveble/billreceiveble'
import category from '@/store/modules/category/category'
import commission from '@/store/modules/commission/commission'
import userdata from '@/store/modules/user/user'
import activity from '@/store/modules/activity/activity'
import productsPrintTag from '@/store/modules/product/productsPrintTag'
import print from '@/store/modules/app/print'

Vue.use(Vuex)

const store = new Vuex.Store({

  modules: {
    app,
    notification,
    auth,
    events,
    account,
    accountResume,
    accountTransaction,
    accountTransfer,
    accountPlan,
    person,
    purchase,
    accountCashFlow,
    drawer,
    xml,
    invoice,
    order,
    orderForm,
    products,
    product,
    billpayable,
    billreceiveble,
    category,
    commission,
    userdata,
    activity,
    order,
    productsPrintTag,
    print
  },

  state: {

    subscribe: {},
    subscriptions: {},

    active_subscription: {},



    firstLoad: false,

    pageHasLoaded: false,

    userHasLoaded: false,

    user: {},

    salesmans: {},

    user_permissions: [],

    company: {
      last_subscription: {


      }
    },

    notifications: [],

    // account: {},

    company_config: {},

    //account_plans: null,

    activePage: null,

    loading: false,

    appAlert: {
      message: null,
      variant: 'success', // todo change to 'type' to 'variant'
    },

  },

  mutations: {


    hideLoading(state) {
      state.loading = false;
    },

    showLoading(state) {
      state.loading = true;
    },

    showAlert(state, { message, variant }) {

      console.log(typeof variant, variant)
      state.appAlert.message = message
      state.appAlert.variant = (typeof variant != 'undefined') ? variant : 'success'
    },

    pageHasLoaded(state) {

      state.pageError = null

      state.pageHasLoaded = true

      state.firstLoad = true
    },

    pageHasLoadedWithError(state, { error }) {

      state.pageError = error

      state.pageHasLoaded = true
    },

    userHasLoaded(state, { data }) {
      state.subscriptions = data.subscriptions
      state.active_subscription = data.company.last_subscription
      state.user = data.user
      state.company = data.company
      //state.account = data.account
      //state.account_plans = data.account_plans
      state.notifications = data.notifications
      state.company_config = data.company_config
      state.user_permissions = data.user_permissions
      state.salesmans = data.salesmans

      state.userHasLoaded = true

      if (typeof bugsnagClient != 'undefined') {
        bugsnagClient.user = {
          id: state.user.id,
          name: state.user.name,
          email: state.user.email
        }
      }

    },

    userHasLoadedWithError(state, { error }) {

      state.pageError = error

      state.userHasLoaded = true
    },

    pageChanged(state, { page }) {

      state.activePage = page

      state.pageHasLoaded = false
    },

    updateCompany(state, { company }) {

      state.company = company

    },

    updateCompanyConfig(state, { company_config }) {

      state.company_config = company_config

    },

    newNotification(state, { notification }) {
      state.notifications.push(notification)
    },


    setSubscription(state, { data }) {
      state.subscribe = data
    },

  },

  actions: {



  },

  getters: {


    userPermissionProductIndex: state => {
      const permission = state.user_permissions.filter((row) => {
        return (row.permission == 'productIndex')
      })[0]

      if (typeof permission == 'undefined') {
        return false
      }

      return (permission.has_permission == 1)

    },

    userPermissionProductCreateEdit: state => {
      const permission = state.user_permissions.filter((row) => {
        return (row.permission == 'productCreateEdit')
      })[0]

      if (typeof permission == 'undefined') {
        return false
      }

      return (permission.has_permission == 1)

    },

    userPermissionStockTransactionIndex: state => {
      const permission = state.user_permissions.filter((row) => {
        return (row.permission == 'stockTransactionIndex')
      })[0]

      if (typeof permission == 'undefined') {
        return false
      }

      return (permission.has_permission == 1)

    },

    userPermissionStockTransactionCreateEdit: state => {
      const permission = state.user_permissions.filter((row) => {
        return (row.permission == 'stockTransactionCreateEdit')
      })[0]

      if (typeof permission == 'undefined') {
        return false
      }

      return (permission.has_permission == 1)

    },

    userPermissionStockTransactionCancel: state => {
      const permission = state.user_permissions.filter((row) => {
        return (row.permission == 'stockTransactionCancel')
      })[0]

      if (typeof permission == 'undefined') {
        return false
      }

      return (permission.has_permission == 1)

    },

  }
})

export default store
